import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import { Screen } from "@/components/kit";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Stars } from "@/components/reviews/Stars";
import { ReviewForm } from "@/components/reviews/ReviewForm";

export default function ReviewsPage() {
  const { t } = useLang();
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.reviews().then(setData).catch(() => setData({ items: [], count: 0 })); }, []);

  const share = async () => {
    const url = `${window.location.origin}/reviews`;
    const text = t("What drivers say about Fuel Hauler Pro");
    try {
      if (navigator.share) await navigator.share({ title: "Fuel Hauler Pro", text, url });
      else { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 2500); }
    } catch { /* user closed share sheet */ }
  };

  return (
    <Screen testID="reviews-screen" title={t("Driver reviews")} subtitle={t("What other haulers say")}>
      <div className="card review-summary" data-testid="review-summary">
        {data?.count ? (<><div className="review-avg" data-testid="review-average">{data.average.toFixed(1)}</div>
          <Stars value={Math.round(data.average)} size={20} testid="review-average-stars" />
          <div className="card-sub" data-testid="review-count">{t("{n} review(s)", { n: data.count })}</div></>)
          : <div className="card-sub" data-testid="review-none">{data ? t("No reviews yet. Be the first.") : "…"}</div>}
        <button type="button" className="ghost-btn" data-testid="review-share" onClick={share}><Share2 size={16} />{copied ? t("Link copied") : t("Share")}</button>
      </div>
      <ReviewForm />
      {data?.items.map((r) => (
        <div key={r.id} className="card review-item" data-testid={`review-${r.id}`}>
          <div className="review-top"><Stars value={r.stars} size={14} testid={`review-stars-${r.id}`} /><b>{r.name || t("Anonymous")}</b>
            <span className="card-sub">{new Date(r.created_at).toLocaleDateString()}</span></div>
          <p className="review-text" data-no-metric="">{r.text}</p>
        </div>
      ))}
    </Screen>
  );
}
